/**
 * caption-opens-discussion — which sheet a tap on the legend opens.
 *
 * Where a conversation exists (`canReply`: a private circle), the discussion —
 * the legend sits at its top and the reader can answer it. On Racore Official,
 * where replying is refused, the legend sheet: the only way to read a long
 * legend in full, since the card truncates it to two lines.
 */
export function captionSheetFor(canReply: boolean): 'discussion' | 'caption' {
  return canReply ? 'discussion' : 'caption';
}
